module.exports = __webpack_public_path__ + "img/22.d7649669.png";